import { network as actions } from '../actions'

export const initialState = {
  id: null,
  title: '',
  members: [],
  admins: [],
  owner: null,
  '@network/logo': null
}

export const setNetwork =
  (network, ops = {}) =>
  dispatch =>
    dispatch({
      type: actions.SET_NETWORK,
      network,
      ops
    })

export const addNetworkActivities = payload => dispatch =>
  dispatch({
    type: actions.ADD_ACTIVITIES,
    payload
  })

export const setNetworkPendingBoards = boards => dispatch =>
  dispatch({
    type: actions.SET_NETWORK_PENDING_BOARDS,
    payload: boards
  })
